module.exports = __webpack_public_path__ + "img/Byleway.92849ad4.jpg";